import { logger } from '@nanostores/logger'
import { accountInfoStore, agentStore, cartStore, userStore } from '../stores/stores'
import { useStore } from '@nanostores/react'
import { debugStore } from '../stores/debug-store'
import { mySelectedStore } from '../stores/my-selected-store'
import { themeStore } from '../stores/theme-store'

import { useEffect } from 'react'
import { manifest } from '../stores/manifest-store'

export const NanostoreLogger = () => {
  const $debug = useStore(debugStore)

  let destroy: Function

  useEffect(() => {
    if ($debug.debugNanostores) {
      destroy = logger({
        userStore: userStore,
        accountInfoStore: accountInfoStore,
        cartStore: cartStore,
        agentStore: agentStore,
        mySelectedStore: mySelectedStore,
        themeStore: themeStore,
        manifest: manifest,
      })
    } else {
      if (destroy) {
        destroy()
      }
    }
  }, [$debug])
}
